import { render } from "./BewerbungComponent.vue?vue&type=template&id=2853e0a8&scoped=true"
import script from "./BewerbungComponent.vue?vue&type=script&lang=js"
export * from "./BewerbungComponent.vue?vue&type=script&lang=js"

import "./BewerbungComponent.vue?vue&type=style&index=0&id=2853e0a8&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2853e0a8"]])

export default __exports__